import { axiosGateway } from "../../../api/axios";
import Cookies from "js-cookie";
import { normalizeGuidedRole } from "../constants/guidedRoles";

const GUIDED_CAPABILITIES_ENDPOINT = "/assistant/guided/capabilities";
const GUIDED_START_ENDPOINT = "/assistant/guided/start";
const GUIDED_CONTINUE_ENDPOINT = "/assistant/guided/continue";
const GUIDED_CANCEL_ENDPOINT = "/assistant/guided/cancel";

const readStorage = (key) => {
  try {
    return localStorage.getItem(key) || Cookies.get(key) || null;
  } catch {
    return Cookies.get(key) || null;
  }
};

const getGuidedAuthConfig = (role) => {
  const normalizedRole = normalizeGuidedRole(role);
  const doctorToken =
    readStorage("doctorToken") ||
    readStorage("doctorAccessToken") ||
    readStorage("doctor_token") ||
    readStorage("doctor_accessToken") ||
    readStorage("doctor_auth_token");
  const patientToken =
    readStorage("accessToken") ||
    readStorage("auth_token");
  const token = normalizedRole === "doctor"
    ? doctorToken || patientToken
    : patientToken || doctorToken;

  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getGuidedCapabilities = async (role) => {
  const res = await axiosGateway.get(GUIDED_CAPABILITIES_ENDPOINT, {
    params: { role: normalizeGuidedRole(role) },
    ...getGuidedAuthConfig(role),
  });
  return res.data;
};

export const startGuidedFlow = async ({ sessionId, role, actionId, locale = "fr", context = {} }) => {
  const res = await axiosGateway.post(GUIDED_START_ENDPOINT, {
    sessionId,
    role: normalizeGuidedRole(role),
    actionId,
    locale,
    context,
  }, { ...getGuidedAuthConfig(role), sanitizeRequest: false });
  return res.data;
};

export const continueGuidedFlow = async ({ sessionId, role, flowId, stepId, locale = "fr", payload = {} }) => {
  const res = await axiosGateway.post(GUIDED_CONTINUE_ENDPOINT, {
    sessionId,
    role: normalizeGuidedRole(role),
    flowId,
    stepId,
    locale,
    payload,
  }, { ...getGuidedAuthConfig(role), sanitizeRequest: false });
  return res.data;
};

export const cancelGuidedFlow = async ({ sessionId, role }) => {
  const res = await axiosGateway.post(GUIDED_CANCEL_ENDPOINT, {
    sessionId,
    role: normalizeGuidedRole(role),
  }, { ...getGuidedAuthConfig(role), sanitizeRequest: false });
  return res.data;
};
